import { useEffect, useState } from "react";

import { getFeatureFlagKey, getFeatureFlagUrl } from "src/env";

interface FlagValueResponse {
  key: string;
  state: string;
  value: FFValue;
}

type FFValue = { boolean: string } | { string: string } | { json: unknown };

export function useFeatureFlagValue(key: string): FFValue | null {
  const [value, setValue] = useState<FFValue | null>(null);

  useEffect(() => {
    const url = getFeatureFlagUrl();
    const ffKey = getFeatureFlagKey();
    if (!url || !ffKey) return;

    fetch(`${url}/v1/flags/${encodeURIComponent(key)}/value`, {
      headers: { Authorization: `Key ${ffKey}` },
    })
      .then<FlagValueResponse>((res) => {
        if (!res.ok) return Promise.reject(new Error(`FF ${key}: ${res.status}`));
        return res.json();
      })
      .then((data) => setValue(data.value))
      .catch(() => {
        // default null on any error (network failure, non-ok response, bad body)
      });
  }, [key]);

  return value;
}

export function useFeatureFlag(key: string): boolean {
  const value = useFeatureFlagValue(key);
  return value !== null && "boolean" in value && value.boolean === "true";
}
